// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"t0-z","upvoteIcon":"u0-z","downvoteIcon":"v0-z","feedbackIcon":"w0-z"};